import React, { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

const ContactPage = ({ language, setLanguage }) => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission placeholder
    alert(language === 'zh' ? '感謝您的留言！我們會盡快與您聯繫。' : 'Thank you for your message! We will get back to you shortly.');
    setFormData({ name: '', email: '', phone: '', message: '' });

  };

  const isZh = language === 'zh';

  return (
    <div className="App">
      <Header language={language} setLanguage={setLanguage} />

      {/* Breadcrumb */}
      <section className="breadcrumb__section cmn__bg pt-120 pb-120">
        <div className="container">
          <div className="breadcrumb__content text-center">
            <h2 className="white">{isZh ? '聯絡我們' : 'Contact'}</h2>
            <ul className="breadcrumb d-flex justify-content-center gap-2">
              <li><a href="/">{isZh ? '首頁' : 'Home'}</a></li>
              <li><span className="white">/</span></li>
              <li><span className="white">{isZh ? '聯絡我們' : 'Contact'}</span></li>
            </ul>
          </div>
        </div>
      </section>

      {/* Let's Start Something */}
      <section className="contact__section pt-120 pb-120">
        <div className="container">
          <div className="row g-4 align-items-start">
            {/* Left: Contact Info */}
            <div className="col-lg-5">
              <div className="contact__leftside">
                <span className="common__sub">{isZh ? '開始合作' : "Let's Start Something"}</span>
                <h2 className="fw-500 mt-2 mb-4">
                  {isZh ? '與我們取得聯繫' : "Get In Touch With Us"}
                </h2>
                <p className="mb-40">
                  {isZh
                    ? '歡迎隨時與我們聯繫，我們的團隊將竭誠為您提供專業的電動車充電解決方案。'
                    : 'Feel free to reach out. Our team is ready to provide professional EV charging solutions tailored to your needs.'}
                </p>

                <div className="contact__box d-grid gap-4">
                  <div className="contact__item d-flex align-items-start gap-3">
                    <div className="icon">
                      <i>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1.4em" height="1.4em" fill="currentColor">
                          <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                        </svg>
                      </i>
                    </div>
                    <div className="content">
                      <span className="address d-block">{isZh ? '地址' : 'Address'}</span>
                      <span className="textp">{isZh ? '香港 灣仔 盧押道18號 海德中心 7B室' : 'RM B, 7/F, One Capital Place, 18 Luard Road, Wan Chai, Hong Kong'}</span>
                    </div>
                  </div>
                  <div className="contact__item d-flex align-items-start gap-3">
                    <div className="icon">
                      <i>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1.4em" height="1.4em" fill="currentColor">
                          <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                        </svg>
                      </i>
                    </div>
                    <div className="content">
                      <span className="address d-block">{isZh ? '電郵' : 'Email'}</span>
                      <a className="textp" href="mailto:hkevgo@gmail.com">hkevgo@gmail.com</a>
                    </div>
                  </div>
                  {/* <div className="contact__item d-flex align-items-start gap-3">
                    <div className="icon">
                      <i>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1.4em" height="1.4em" fill="currentColor">
                          <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                        </svg>
                      </i>
                    </div>
                    <div className="content">
                      <span className="address d-block">{isZh ? '電話' : 'Call Now'}</span>
                      <a className="textp" href="tel:+85200000000">+852 0000 0000</a>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            {/* Right: Leave a Reply Form */}
            <div className="col-lg-7">
              <div className="contact__rightside">
                <span className="common__sub">{isZh ? '留言' : 'Leave a Reply'}</span>
                <h3 className="fw-500 mt-2 mb-4">
                  {isZh ? '發送訊息給我們' : 'Send Us a Message'}
                </h3>
                <form onSubmit={handleSubmit} className="contact__form">
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder={isZh ? '您的姓名 *' : 'Your Name *'}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder={isZh ? '電郵地址 *' : 'Email Address *'}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder={isZh ? '電話號碼' : 'Phone Number'}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <textarea
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          rows="6"
                          placeholder={isZh ? '您的留言 *' : 'Your Message *'}
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <button type="submit" className="d-flex fw-500 cmn--btn align-items-center gap-2">
                        <span>{isZh ? '發送訊息' : 'Send Message'}</span>
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor">
                            <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <Footer /> */}
    </div>
  );
};

export default ContactPage;
